import { CoordinatorService } from './coordinator.service';
import { MyWorker } from './worker';

export class Worker$ {
    autotag: MyWorker;
    online: MyWorker;
    parser: MyWorker;
    export: MyWorker;
    manifest: MyWorker;
    report: MyWorker;
    batch: MyWorker;

    constructor(private coords: CoordinatorService) {
        this.export = new MyWorker(this.coords, 'export', 'workers/export-worker.js');
        this.online = new MyWorker(this.coords, 'online', 'workers/online-worker.js');
        this.manifest = new MyWorker(this.coords, 'manifest', 'workers/manifest-worker.js');
        this.autotag = new MyWorker(this.coords, 'autotag', 'workers/autotag-worker.js');
        this.parser = new MyWorker(this.coords, 'parser', 'workers/parser-worker.js');
        this.report = new MyWorker(this.coords, 'report', 'workers/report-worker.js');
        this.batch = new MyWorker(this.coords, 'batch', 'workers/batch-worker.js');
    }

    get isReady() {
        const isReady =
            this.coords.manifest$.isReady &&
            this.coords.databin$.isReady &&
            this.coords.worker$.autotag.isReady;

        return isReady;
    }
}
